<!--<vl-form-validation-observer v-slot="{ handleSubmit, invalid, pristine }">-->
    <form class="vl-form" @submit="onSubmit">
        <vl-modal id="una-zone-move-modal" mod-medium :closable="true">
            <vl-title tag-name="h3">Verplaats zone</vl-title>
            <vl-form-grid mod-stacked>
                <vl-column>
                    <kl-field-validation-wrapper-yup :field="fields.selectedDestinationOrganisation" #default="{hasErrors}" mod-required>
                        <kl-search-organisation @selected="onOrganisationSelect" v-model="selectedDestinationOrganisation" :mod-error="hasErrors" :show-id="true" :only-include-una-organisations="true" />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column v-if="selectedDestinationOrganisation">
                    <div v-kl-u-background-alt v-kl-u-box-padding>{{ selectedDestinationOrganisation.namePath }}</div>
                </vl-column>
                <vl-column>
                    <kl-field-validation-wrapper-yup :field="fields.reason" #default="{hasErrors}" mod-required>
                        <vl-textarea rows="6" name="reason" id="reason" v-model="reason" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column>
                    <kl-field-validation-wrapper-yup :field="fields.mailTo" #default="{hasErrors}" mod-required>
                        <vl-textarea rows="6" name="mailTo" id="mailTo" v-model="mailTo" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
            </vl-form-grid>

            <template v-slot:modal-footer>
                <vl-action-group>
                    <vl-button type="submit" mod-large :mod-loading="movingZone" :mod-disabled="disableSubmit">Verplaats zone</vl-button>
                    <vl-button type="button" mod-link @click.prevent="onCancelMoveUnaZone" icon="cross" mod-icon-before>Annuleer</vl-button>
                </vl-action-group>
            </template>
        </vl-modal>
    </form>
<!--</vl-form-validation-observer>-->
